import { render } from "./InformationActionsBtn.vue?vue&type=template&id=0fed2f16&ts=true"
import script from "./InformationActionsBtn.vue?vue&type=script&lang=ts"
export * from "./InformationActionsBtn.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__